@defer {
  <app-form [fields]="fields" [options]="{ attachments: false, multi: false, head: false, foot: false, title: false }" [mode]="mode" [listenForRouteChanges]="false" />
}
